import { AuthorInfo } from '@c/AuthorInfo';
import Button from '@ui/Button';
import SafeImage from '@ui/SafeImage';
import { BlogDocument } from '@util/types/firestore/blog';
import Link from 'next/link';

const blogUrl = (slug?: string) => `/blog/${slug || ''}`;

interface FeaturedBlogCardProps {
  blog: Partial<BlogDocument>;
}

const FeaturedBlogCard = ({ blog }: FeaturedBlogCardProps) => {
  const firstTag = blog.categories?.[0].name ?? 'General';
  const slug = blog.slug ?? '';
  const title = blog.title ?? 'Untitled';
  const description = blog.description ?? '';
  const thumbnail = blog.thumbnail ?? '';


  return (
    <div className="flex flex-col items-center gap-[2.4rem] md:flex-row">
      {/* image */}
      <Link
        href={blogUrl(slug)}
        className="relative h-[22rem] w-full overflow-clip rounded-[10px] sm:h-[42rem] lg:w-[68.8rem]"
      >
        <SafeImage
          alt={title}
          src={thumbnail}
          fill={true}
          style={{ objectFit: 'cover' }}
        />
        <div className="absolute bottom-[1.6rem] left-[1.6rem] rounded-[10px] bg-brand-white-20 px-[1.6rem] py-[0.6rem] text-[1.3rem] font-semibold text-brand-white">
          {firstTag}
        </div>
      </Link>

      {/* info */}
      <div className="max-w-[48.6rem] grow self-stretch">
        <div className="flex w-full flex-col gap-[1.6rem] sm:gap-[2.4rem] sm:p-[2.4rem]">
          <AuthorInfo blog={{ ...blog, author: blog.author || 'GearFocus' }} />

          <Link
            href={blogUrl(slug)}
            className="text-[2.4rem] font-semibold leading-[2.4rem] sm:text-[3.2rem] sm:leading-[4.16rem]"
            itemProp="headline"
          >
            {title}
          </Link>

          <div
            style={{
              lineHeight: '2.25rem',
              display: '-webkit-box',
              WebkitLineClamp: 3,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}
            itemProp="description"
          >
            {description}
          </div>

          <div className="max-w-[15.3rem]">
            <Button
              text="Read Article"
              type="secondary"
              href={blogUrl(slug)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturedBlogCard;